import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';

@Component({
  selector: 'app-device-edit-modal',
  templateUrl: './device-edit-modal.component.html',
  styleUrls: ['./device-edit-modal.component.scss'],
})
export class DeviceEditModalComponent implements OnInit {
  deviceForm = new UntypedFormGroup({
    terminalId: new UntypedFormControl({ value: '', disabled: this.data.KaID != null }),
    merchantName: new UntypedFormControl(''),
    serialNumber: new UntypedFormControl({ value: '', disabled: this.data.KaID != null }),
  });
  saving = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: { DeviceID: number; TerminalID: string; MerchantName: string; SerialNumber: string, KaID?: number },
    private dialogRef: MatDialogRef<DeviceEditModalComponent>,
    private genericService: GenericService,
    private endpoints: Endpoints,
  ) { }

  ngOnInit() {
    console.log(this.data);
    this.deviceForm.setValue({
      terminalId: this.data.TerminalID,
      merchantName: this.data.MerchantName,
      serialNumber: this.data.SerialNumber,
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.saving = true;
    this.genericService
      .PUT(this.endpoints.UPDATE_DEVICE_MERHCANT_AND_TERMINAL(this.data.DeviceID), {
        TerminalID: this.deviceForm.value.terminalId ?? "",
        MerchantName: this.deviceForm.value.merchantName,
        SerialNumber: this.deviceForm.value.serialNumber ?? "",
      })
      .subscribe(
        () => {
          this.saving = false;
          this.dialogRef.close({
            TerminalID: this.deviceForm.value.terminalId,
            MerchantName: this.deviceForm.value.merchantName,
            SerialNumber: this.deviceForm.value.serialNumber,
          });
        },
        () => {
          this.saving = false;
        },
      );
  }
}

export function openDeviceEditDialog(dialog: MatDialog, data: { DeviceID: number; TerminalID: string; MerchantName: string; SerialNumber: string, KaID?: number }) {
  const config = new MatDialogConfig();
  config.data = data;
  config.minHeight = '200px';
  const dialogRef = dialog.open(DeviceEditModalComponent, config);
  return dialogRef.afterClosed();
}
